import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { HeaderContainer } from './styled';
export function MenuHeader(props) {
    const { title, sticky = true, action, className } = props;
    const dataId = sticky ? 'menu-header-sticky' : undefined;
    return (<HeaderContainer $sticky={sticky} data-id={dataId} className={className}>
      <Typography $appearance="300" $fontSize="small">
        {title}
      </Typography>
      {action && <Box ml="auto">{action}</Box>}
    </HeaderContainer>);
}
